import { Navigate, Outlet } from "react-router-dom";

export default function ViewerPrivateRoute() {
    const isAuthenticated = localStorage.getItem("viewer_token") === "authenticated";
    return isAuthenticated ? <Outlet /> : <Navigate to="/impacthub_login" replace />;
}
